module.exports = "/../../dist/frontend/images/heroattestations.webp?2db9b39b0e261b48f2696b35d7a437c5";